import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "children", "theme"];
import { FastField } from 'formik';
import React from 'react';
import { useInitialOrDefaultFieldValue } from '../../hooks/useInitialOrDefaultFieldValue';
import { CheggUiCheckbox } from './styled';
export var Checkbox = function Checkbox(_ref) {
  var name = _ref.name,
    children = _ref.children,
    _theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  useInitialOrDefaultFieldValue(name, '0');
  return /*#__PURE__*/React.createElement(FastField, {
    name: name
  }, function (_ref2) {
    var field = _ref2.field,
      form = _ref2.form;
    return /*#__PURE__*/React.createElement(CheggUiCheckbox, _extends({}, rest, {
      onChange: function onChange(control) {
        return form.setFieldValue(name, control.currentTarget.checked ? '1' : '0');
      },
      checked: field.value === '1'
    }), children);
  });
};